export default __webpack_public_path__ + "media/src/assets/images/CancelIcon-40bfae3f8c7635ea660c3c66eacb6671.svg";